import gql from 'graphql-tag';
import apolloClient from '../../../ConnectionManager/apolloClient';

const queryLTIMessage = gql`
  query getLTIMessage (
    $pluginId: UUID!,
    $url: String!,
    $key: String!,
    $params: [LTILaunchRequestParamInput]!
  ) {
    pluginById(id: $pluginId) {
      lti {
        toolProvider {
          signLaunch(url: $url, key: $key, params: $params) {
            method
            url
            formParameters
          }
        }
      }
    }
  }
`;

export default async ({ pluginId, url, key, params }) => {
  const response = await apolloClient.query({
    query: queryLTIMessage,
    variables: {
      pluginId,
      url,
      key,
      params: Object.entries(params).map(([name, value]) => ({ name, value })),
    },
    errorPolicy: 'all',
  });

  if (response.errors) {
    throw new Error(response.errors);
  }

  return response;
};
